import { useEffect, useState } from "react";
import ml5 from "ml5";
import ResultContainer from "./components/ResultContainer";
import { Helmet, HelmetProvider } from "react-helmet-async";
import KakaoButton from "./components/KakaoButton";
import dogDictionary from "./db/dogDatabase";
import KakaoAd from "./components/KakaoAd";
import ResultChart from "./components/ResultChart";

function App() {
  const [result, setResult] = useState([]);
  const [attachment, setAttachment] = useState(null);
  const [dogImage, setDogImage] = useState(null);
  const [classifier, setClassifier] = useState(null);
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const [closestDog, setClosestDog] = useState(null);

  useEffect(() => {
    const result = ml5.imageClassifier("model.json", () => {
      setClassifier(result);
    });
  }, []);

  // setInterval(() => {
  //   console.log(classifier);
  // }, 1000);

  const findClosestDog = (dogArray) => {
    return dogArray.reduce((prev, current) =>
      prev.confidence > current.confidence ? prev : current
    );
  };

  const onStart = () => {
    if (classifier === null) return;
    setIsAnalyzing(true);

    const image = document.getElementById("attachment");
    // console.log(classifier);
    classifier.classify(image, (error, results) => {
      //find result
      if (error) {
        console.log(error);
        return;
      }
      setResult(results);

      //가장 근접한 개 찾기
      let theDog = findClosestDog(results);
      setClosestDog(theDog);
      updateDogImage("/dogImages/" + dogDictionary[theDog.label].imageUrl);

      setIsAnalyzing(false);
    });
  };

  const onFileChanged = (event) => {
    setResult([]);
    const {
      target: { files },
    } = event;
    if (files.length === 0) return;
    const theFile = files[0];
    const reader = new FileReader();
    reader.onloadend = (finishedEvent) => {
      const {
        currentTarget: { result },
      } = finishedEvent;
      setAttachment(result);
    };
    reader.readAsDataURL(theFile);
  };

  const onClickRedo = () => {
    setResult([]);
    setAttachment(null);
    setDogImage(null);
    setClosestDog(null);
  };

  const updateDogImage = (url) => {
    setDogImage(url);
  };

  return (
    <div className="doggyfaceApp">
      <img src="shibaFace.png" alt="shibaFace" width="300" />
      <div className="title">견상 테스트</div>
      <div className="emojis-dog">{"        "}🐕‍🦺🐩🦮</div>
      <div className="subTitle">나는 어떤 개상인가?</div>

      {attachment === null ? (
        <>
          <label className="input-image-button" htmlFor="input-file">
            사진 고르기
          </label>
          <input
            id="input-file"
            type="file"
            accept="image/*"
            onChange={onFileChanged}
            style={{ display: "none" }}
          ></input>
        </>
      ) : (
        <>
          {isAnalyzing ? (
            <>
              <div className="loading"></div>
              <div className="txt-loading">견상 분석 중...</div>
            </>
          ) : (
            <>
              {result.length > 0 ? (
                <>
                  <div className="result-Images">
                    <img
                      className="result-Image"
                      id="attachment"
                      src={attachment}
                      alt="myface"
                      width="200"
                    />
                    <img
                      className="result-Image"
                      id="dogImage"
                      src={dogImage}
                      alt="myface"
                      width="200"
                    />
                  </div>
                  <ResultChart result={result} />
                  <button className="btn-analyze" onClick={onClickRedo}>
                    다시하기
                  </button>
                </>
              ) : (
                <>
                  <img
                    className="result-Image"
                    id="attachment"
                    src={attachment}
                    alt="myface"
                    width="200"
                  />
                  <button className="btn-analyze" onClick={onStart}>
                    견상 분석하기
                  </button>
                </>
              )}
            </>
          )}
        </>
      )}
      {result.length > 0 && closestDog && (
        <ResultContainer closestDog={closestDog} />
      )}
      <div className="safe-notice">※사진은 어디에도 저장되지 않습니다</div>
      <div className="safe-notice">(개발자도 못봐요~)</div>
      <KakaoButton />
      <HelmetProvider>
        <Helmet>
          <script src="https://developers.kakao.com/sdk/js/kakao.js"></script>
        </Helmet>
      </HelmetProvider>
      <KakaoAd />
      <footer>
        <div>&copy; {new Date().getFullYear()} lefthanddeveloper</div>
        <div>Thanks to Rich Yoo</div>
      </footer>
    </div>
  );
}

export default App;
